<template>
    <popup
        class="video-player"
        v-model="isShow">
        <div class="video-player__inner"
            @click="close">
            <video
                :src="url"
                ref="video"
                preload="metadata"
                playsinline
                webkit-playsinline
                x5-playsinline
                controls
                autoplay
                @click.stop></video>
            <i class="video-player__close icon_close"
                @click="close"></i>
        </div>
    </popup>
</template>

<script>
    import { Popup } from 'vant'
    import {
        pageVisibility,
        stopAllAudio
    } from '@/utils/dom'

    const {
        PAGE_HIDDEN,
        visibilityChange,
        isSupportVisibilityChange
    } = pageVisibility

    export default {
        name: 'TheVideoPlayer',
        components: {
            Popup
        },
        data () {
            return {
                isShow: false,
                url: '',
                $video: null,
                visibilitychangeHandleSelf: this.visibilitychangeHandle.bind(this)
            }
        },
        watch: {
            isShow (value) {
                if (!value) {
                    const $video = this.getVideoRef()
                    if ($video && !$video.paused) {
                        this.pause()
                    }
                }
            }
        },
        methods: {
            show () {
                if (!this.isShow) {
                    this.isShow = true
                }
            },
            play () {
                this.$audioPlayer.stop()
                stopAllAudio() // 停止所有音频播放器

                const $video = this.getVideoRef()
                if ($video) {
                    const promise = $video.play()
                    // https://stackoverflow.com/a/41822526
                    if (promise !== undefined) {
                        promise.catch(() => {
                            $video.play()
                        })
                    }
                }
            },
            stop () {
                const $video = this.getVideoRef()

                if ($video) {
                    $video.pause()
                    this.setCurrentTime(0)
                }
            },
            pause () {
                const $video = this.getVideoRef()
                if ($video) {
                    $video.pause()
                }
            },
            setUrl ({ url }) {
                this.setCurrentTime(0)
                this.url = url
            },
            setCurrentTime (time = 0) {
                const $video = this.getVideoRef()
                if ($video) {
                    $video.currentTime = time
                }
            },
            close () {
                this.isShow = false
            },
            getVideoRef () {
                return this.$refs.video
            },
            visibilitychangeHandle () {
                if (document[PAGE_HIDDEN]) {
                    this.pause()
                }
            }
        },
        mounted () {
            if (isSupportVisibilityChange) {
                document.addEventListener(visibilityChange, this.visibilitychangeHandleSelf, false)
            }
        },
        beforeDestroy () {
            if (isSupportVisibilityChange) {
                document.removeEventListener(visibilityChange, this.visibilitychangeHandleSelf, false)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .video-player {
        width: 100%;
        height: 100%;
        background-color: transparent;

        &__inner {
            width: 100%;
            height: 100%;
        }

        &__close {
            position: absolute;
            right: 15px;
            top: 15px;
            width: 20px;
            height: 20px;
            color: #fff;
            font-size: 20px;
            font-weight: 200;
            cursor: pointer;
        }

        video {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
        }
    }
</style>
